export default __webpack_public_path__ + "static/media/20140928_163526.a8e752cb-min.44a31176.jpg";